import { Box, createStyles, Title } from '@mantine/core';
import React from 'react';

import { useStoreListingWizard } from './hooks';
import { PreviewColumn } from './PreviewColumn';
import { OnCloseCallback, StepId } from './types';
import { WizardFooter } from './wizard-footer/WizardFooter';
import { WizardNavigation } from './wizard-navigation/WizardNavigation';

interface WizardContentProps {
  onClose: OnCloseCallback;
}

export function WizardContent({ onClose }: WizardContentProps) {
  const { classes } = useStyles();
  const { currentStep, contextData } = useStoreListingWizard();

  const isCreate = contextData.intent === 'create';

  const getStepTitle = () => {
    if (currentStep.id === StepId.ChooseProduct) {
      return isCreate ? 'Choose Product' : 'Product Information';
    }

    if (currentStep.id === StepId.PaymentSettings) {
      return 'Payment Settings';
    }
  };

  const showPreviewColumn =
    !isCreate || currentStep.id !== StepId.ChooseProduct;

  return (
    <div className={classes.container}>
      <div className={classes.mainContent}>
        <WizardNavigation />

        <Box className={classes.detailsColumn}>
          <Title order={4} weight={400} mb={42} data-testid="wizard-step-title">
            {getStepTitle()}
          </Title>
          {currentStep.component}
        </Box>

        {showPreviewColumn ? <PreviewColumn /> : null}
      </div>

      {isCreate || contextData.storeListing?.editable === true ? (
        <WizardFooter onClose={onClose} />
      ) : null}
    </div>
  );
}

const useStyles = createStyles(() => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateRows: '1fr max-content',
  },
  mainContent: {
    display: 'grid',
    gridTemplateColumns: '280px 4fr',
    gridAutoFlow: 'column',
    gridAutoColumns: '3fr',
  },
  detailsColumn: {
    display: 'grid',
    gridTemplateRows: 'max-content 1fr',
    paddingTop: 36,
    paddingInline: 30,
    paddingBottom: 30,
  },
}));
